import { FCX, useUuid } from "@datassential/platform-ui-lib";
import './Affinity.scss';

const STROKE = 4;
const WIDTH = 100;
const p = 2 * Math.PI * (WIDTH/2 - STROKE/2);
const getValueP = (v: number) => p * (v / 100);

const FoodAffinity: FCX<{
    value: number;
}> = ({
    value,
}) => {
    const id = useUuid();

    return (
        <div className="FoodAffinity">
            <svg
                className="FoodAffinity__circle"
                viewBox={`0 0 ${WIDTH} ${WIDTH}`} width={WIDTH} height={WIDTH}
            >
                <defs>
                    <linearGradient
                        id={id}
                        x1="0"
                        y1="0"
                        x2="100%"
                        y2="100%"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stopColor="#FF5AB9"></stop>
                        <stop offset="100" stopColor="#EB0089"></stop>
                    </linearGradient>
                </defs>
                <circle
                    cx={WIDTH / 2}
                    cy={WIDTH / 2}
                    r={WIDTH / 2 - STROKE/2}
                    fill="none"
                    strokeWidth={STROKE}
                    stroke={`url(#${id})`}
                    strokeDasharray={`${getValueP(value)}, ${p - getValueP(value)}`}
                />
            </svg>
            <div className="FoodAffinity__value">
                <div
                    className="FoodSectionConsumer__blur"
                    data-testid="textFoodConsumerAffinityValue"
                >
                    {Math.round(value)}
                </div>
            </div>
            <div
                className="FoodAffinity__label"
                data-testid="textFoodConsumerAffinityLabel"
            >
                love or<br/>like it
            </div>
        </div>
);
}

export default FoodAffinity;